import { API } from "../../api";
async function verify_client_otp(request) {
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/verify/client/otp`,
        content: request,
    });
}
export { verify_client_otp };
